import clsx from "clsx";
import React, { FunctionComponent, ReactNode } from "react";

import { StatusBar } from "../../../ui/StatusBar/StatusBar";
import { TireQuickSeasonFilters } from "../../Tires/Results/Filters/TireSeasonFilters/TireQuickSeasonFilters";
import { useTireResults } from "../../Tires/Results/useTireResults";

type CombosStatusbarProps = {
  children: ReactNode;
  className?: string;
};

export const CombosStatusbar: FunctionComponent<CombosStatusbarProps> = ({
  children,
  className,
}) => {
  const { isLoading } = useTireResults();

  return (
    <StatusBar
      className={clsx("mb-4 md:mb-6 lg:mb-9 flex-wrap gap-1", className)}
      isLoading={isLoading}
    >
      {children}
      <TireQuickSeasonFilters />
    </StatusBar>
  );
};
